<template>
  <SfModal
    visible
    :title="$t('VAT ID Validation Issues')"
    :narrow="true"
    @close="closeModal"
  >
    <div class="flex flex-1 flex-col h-full text-center">
      <p class="text-md text-left pb-4">
        {{ $t('There was a problem validating your VAT ID. Here are the possible reasons:') }}
      </p>

      <ul class="text-left text-sm pb-6 space-y-1 pl-7">
        <li
          v-for="reason in reasons"
          :key="reason.title"
        >
          <strong>{{ $t(reason.title) }}</strong> {{ $t(reason.description) }}
        </li>
      </ul>

      <p class="text-sm pb-6 text-left">
        {{ reclaimMessage }}
      </p>

      <div class="flex justify-center">
        <CustomButton
          type="primary"
          class="max-w-sm"
          @click="closeModal"
        >
          {{ $t('Continue with Purchase') }}
        </CustomButton>
      </div>
    </div>
  </SfModal>
</template>

<script lang="ts">

export default defineComponent({
  emits: ['close'],

  setup(_, { emit }) {

    const i18n = useI18n();

    const reasons = ref([
      { title: 'Invalid VAT ID:', description: 'The number entered may be incorrect or does not exist.' },
      { title: 'Private VAT ID:', description: 'A personal VAT ID was used instead of a business one.' },
      { title: 'System Error:', description: 'There was a technical issue.' },
    ]);

    const reclaimMessage = i18n.t(
      'You can still complete your purchase and easily reclaim any taxes ' +
      'by contacting your local tax office with the right documents.',
    );

    const closeModal = () => {

      emit('close');
    
    };

    return {
      closeModal,
      reasons,
      reclaimMessage,
    };
  
  },
});

</script>
